import {DateTime} from "luxon";

export const language = {
	"copyrightText": "© " + DateTime.local().year + " Mariam Razi, All rights reserved."
}
